import React from "react";
import "./styles.scss";
import { LinksSidebar } from "./LinksSidebar";
import Logo from "../../../components/Logo";

export const Sidebar = () => {
  return (
    <div
      className="sidebar d-none d-lg-flex"
      style={{
        height: window.innerHeight
      }}
    >
      <div className="sidebar-inner">
        <div className="d-flex flex-row align-items-center justify-content-between py-4 px-4">
          <Logo />
          <small className="px-3">v1.9.12</small>
        </div>
        <LinksSidebar />
      </div>
    </div>
  );
};
